import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import "./AddButton.scss";
import { updateToAddNodes } from "../../utils/update";

export const AddButton = (props) => {
  const { onClick } = props;
  return (
    <button
      onClick={() => { onClick ? onClick() : updateToAddNodes(props.data)}}
      className={"intent-button"}
    >
      <PlusOutlined />
    </button>
  );
};
